import {Component, Input, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'app-featured-icon',
  templateUrl: './featured-icon.component.html',
  styleUrls: ['./featured-icon.component.css']
})
export class FeaturedIconComponent implements OnInit, OnDestroy {

  @Input()type: any = 'featured';
  @Input()color: any = '';

  constructor() {
  }


  ngOnDestroy() {
  }

  ngOnInit() {
  }
}
